export default __webpack_public_path__ + "static/media/top-k-2.6afd178e.jpg";